import React from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import InputLabel from "@mui/material/InputLabel";

import {getIMEDropdownOptions, IMEFieldsObjectInterface} from "./IMEFieldsFunctions";
import TextInput from "../../../ui/textInput";

const renderFields = ["Category", "Location", "Collection", "Product"];
const inputFields = ["Project Description", "Retail Price"];


const UiPopupIMEFields = (props) => {

  const {IMEFieldsObject, onIMEValueChange, fabricatorData, quotes} = props;

  // console.log("IMEFieldsObject", IMEFieldsObject);

  return (
    <div className={quotes.length > 1 ? "pl-05 pt-05" : ""}>
      <div className="ass-fields p-0 mb-05">
        {inputFields.map(property => {
          const value = IMEFieldsObject[property];
          const errorsExist = false;
          const isSubTotal = property === "Retail Price";
          const onChange = (newValue) => {
            if (!isSubTotal && newValue.length > 36) {
              return
            }
            onIMEValueChange(IMEFieldsObject.uuid, {[property]: isSubTotal ? "" + newValue : newValue});
          };
          if (isSubTotal) {
            return (
              <div className="width--135" key={property}>
                <InputLabel className="text-left bold cursor-default">{property}</InputLabel>
                <span className="bold color-active flex flex--center flex--start font h-25 text-left w-full font--18">
                  {fabricatorData.settings.currencySign + value}
                </span>
              </div>
            )
          }
          return (
            <div className="flex--1 pr-125" key={property}>
              <InputLabel htmlFor={property} className="text-left bold">{property}</InputLabel>
              <TextInput className={"ui-input w-full ui-input--new ass-field__input" + (errorsExist ? " ui-input--error" : "")}
                         numberInput={false}
                         onChange={onChange}
                         onRealChange={onChange}
                         id={property}
                         placeholder={property}
                         usePropsValue={true}
                         currencySing={fabricatorData.settings.currencySign}
                         value={value}/>
            </div>
          )
        })}
      </div>
      {renderFields.map(property => {
        const value = IMEFieldsObject[property] || "placeholder";

        const options = getIMEDropdownOptions(property, IMEFieldsObject["Category"] || "");

        const onChange = (event) => {
          const value = event.target.value;
          const newObject = {[property]: value};
          if (property === "Category") {
            ["Collection", "Product"].forEach(dependantProperty => {
              if (IMEFieldsObject[dependantProperty] &&
                !getIMEDropdownOptions(dependantProperty, value).includes(IMEFieldsObject[dependantProperty])) {
                newObject[dependantProperty] = "";
              }
            });
          }
          onIMEValueChange(IMEFieldsObject.uuid, newObject);
        };

        return (
          <div key={property} className="mb-05">
            <InputLabel htmlFor={property} className="text-left bold">{property}</InputLabel>
            <div className="relative">
              <select name=""
                      className={"ui-input ui-input--select ui-input--new ass-field__input ass-field__select"
                        + (!value || value === "placeholder" ? " ass-field__input--no-value" : "")}
                      value={value}
                      onChange={onChange}>
                <option value="placeholder" disabled hidden >
                  {/*{intl.formatMessage({id: "buttons.select"})}*/}
                  {"Select Item"}
                </option>
                {options.map((method, methodIndex) => {
                  return (
                    <option key={methodIndex} value={method}>{method}</option>
                  )
                })}
              </select>
              <span className="ui-select-triangle"></span>
            </div>
          </div>
        )
      })}
    </div>
  )
};

UiPopupIMEFields.propTypes = {
  IMEFieldsObject: PropTypes.shape(IMEFieldsObjectInterface),
}

const mapStateToProps = (store) => {
  const {quotes} = store.quotesState;

  return {
    fabricatorData: store.fabricatorState,
    quotes,
  };
};

export default injectIntl(
  connect(mapStateToProps)(UiPopupIMEFields)
)

